export interface PublicJourney {
  id: string;
  name: string;
  difficulty: string;
  totalSteps: number;
  category: string;
  position: number;
  isFree: boolean;
}

function nameFromJson(value: unknown): string {
  if (typeof value === 'string') return value;
  if (value != null && typeof value === 'object' && 'en' in value) {
    return (value as Record<string, string>).en;
  }
  return '';
}

export function publicJourneyFromJson(json: Record<string, unknown>): PublicJourney {
  return {
    id: json['id'] as string,
    name: nameFromJson(json['name']),
    difficulty: json['difficulty'] as string,
    totalSteps: json['totalSteps'] as number,
    category: json['category'] as string,
    position: json['position'] as number,
    isFree: (json['isFree'] as boolean | undefined) ?? false,
  };
}
